import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH ASSET GROUP TO EDIT ********************
export const fetchAssetGroup = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ASSET_GROUP_LOADING,
			payload: true
		});

		const { data } = await services.get(`/asset_groups/${id}?with_metadata=1`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ASSET_GROUP_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_ASSET_GROUP_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
